import _ from "lodash";

function transformHistogramData(histogram) {
  const columnKeys = _.keys(histogram);
  const result = {};

  _.forEach(columnKeys, (columnKey) => {
    _.forEach(histogram[columnKey], (value, key) => {
      result[key] = { ...result[key], [columnKey]: value };
    });
  });
  return result;
}

export function getFrontendUrl() {
  const productionUrl = "https://frontend.test.ada.dsa.seiu.org";
  const developmentUrl = "http://localhost:5173/";
  if (window.location.hostname === "localhost") {
    return developmentUrl;
  }
  return productionUrl;
}

export function getBackendUrl() {
  const developmentUrl = "http://127.0.0.1:8000";
  if (window.location.hostname === "localhost") {
    return developmentUrl;
  }
  return import.meta.env.VITE_BACKEND_URL;
}

export const transformFieldData = (fieldData) =>
  fieldData.map((field) => ({
    ...field,
    histogram: transformHistogramData(field.histogram),
  }));

export const parseAdaPath = (path) => {
  const [affiliate, subdir, process_date, dataFile, template, processed_file] =
    path.split("/");
  const [filename, upload_date] = dataFile.split("@");
  const [template_name, template_date] = template.split("@");
  return {
    affiliate,
    subdir,
    process_date,
    filename,
    upload_date,
    template_name,
    template_date,
    processed_file,
  };
};

export const validateEmail = (email) => {
  if (!email) return false;

  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return regex.test(email);
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export function isExcelFile(filename) {
  if (!filename) return "";
  const fileExtension = filename.split(".").pop().toLowerCase();
  return fileExtension.startsWith("xl");
}

export function clearCaches() {
  localStorage.removeItem("formula_data");
  localStorage.removeItem("template_skeleton");
  localStorage.removeItem("priority_fields");
}

export const getValidLocalStorageItem = (key) => {
  const item = localStorage.getItem(key);
  // check if key exists
  if (item === null) return null;
  // check if value is valid
  if (item === "undefined" || item === "null") return null;
  // check for valid JSON
  try {
    const parsed = JSON.parse(item);
    // make sure it's not an empty array
    if (Array.isArray(parsed) && parsed.length === 0) {
      return null;
    }
    return parsed;
  } catch (e) {
    // value string isn't valid JSON
    console.log(
      `The local storage item ${key} is storing an unparsable value ${item} `,
      e
    );
    return null;
  }
};

export function formatLargeNumber(number) {
  // it's a number and not NaN
  if (typeof number === "number" && !isNaN(number)) {
    return number.toLocaleString();
  }
  return "Unable to calculate";
}

export const formatTimestamp = (isoString, dateOnly = false) => {
  const ts = !isoString
    ? ""
    : isoString
        .replace(/\+\d\d:\d\d$/, "") // Remove the +00:00 time zone
        .replace(/\.\d+$/, "") // Remove the microseconds
        .replace("T", " "); // Use space not T for date/time sep
  // Remove everything after space if dateOnly
  return dateOnly ? ts.replace(/ .*/, "") : ts;
};
